<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary">
          <span class="profile-dropdown__anchor min-w-max flex items-center gap-2">
            <span class="company-name">
              {{ 'MP' }}
            </span>
            <slot />
          </span>
        </VaButton>
      </template>

      <VaDropdownContent
        class="profile-dropdown__content md:w-60 px-0 py-4 w-full"
        :style="{ '--hover-color': hoverColor }"
      >
        <VaList v-for="group in defaultOptions" :key="group.name">
          <header v-if="group.name" class="uppercase text-[var(--va-secondary)] opacity-80 font-bold text-xs px-4">
            {{ t(`user.${group.name}`) }}
          </header>

          <VaListItem
            v-for="item in group.list"
            :key="item.name"
            class="menu-item px-4 text-base cursor-pointer h-8"
            v-bind="resolveLinkAttribute(item)"
            @click="onItemClick(item)"
          >
            <VaIcon :name="item.icon" class="pr-1" color="secondary" />
            {{ t(`user.${item.name}`) }}
          </VaListItem>

          <VaListSeparator v-if="group.separator" class="mx-3 my-2" />
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../../../../stores/auth'

const router = useRouter()
const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))
const { t } = useI18n()
const auth = useAuthStore()

// 🔐 Logout aksiyonu
async function logout() {
  auth.logout()
  router.push({ name: 'login' })
}

type ProfileListItem = {
  name: string
  to?: string
  href?: string
  icon: string
  action?: () => void
}

type ProfileOptions = {
  name: string
  separator: boolean
  list: ProfileListItem[]
}

// ⬇️ Varsayılan seçenekleri ayrı tanımla (burada logout'a güvenle referans verebiliriz)
const defaultOptions: ProfileOptions[] = [
  {
    name: '',
    separator: false,
    list: [{ name: 'logout', icon: 'mso-logout', action: logout }],
  },
]

const isShown = ref(false)

// link props: action varsa link vermiyoruz
const resolveLinkAttribute = (item: ProfileListItem) => {
  if (item.action) return {}
  return item.to ? { to: { name: item.to } } : item.href ? { href: item.href, target: '_blank' } : {}
}

// tıklama: action varsa çalıştır, dropdown'ı kapat
const onItemClick = (item: ProfileListItem) => {
  if (item.action) {
    isShown.value = false
    item.action()
  }
}
</script>

<style lang="scss">
.company-name {
  max-width: 180px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}
@media (max-width: 480px) {
  .company-name {
    display: none;
  }
}
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
</style>
